import VVideoCover from './index.vue';

export default {
  install: (Vue) => Vue.component('VVideoCover', VVideoCover),
};
